import React from 'react';
import classnames from 'classnames';
import { Query } from '@apollo/client/react/components';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';
import { Link } from 'react-router-dom';
import { fromGlobalId } from 'graphql-relay';

import LoadingProgress from 'lib/react-router/loading-progress';
import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import { displayedName } from 'four-nets/user/utils';
import EnhancedText from 'four-nets/ui/enhanced-text/enhanced-text';
import ErrorPage from 'four-nets/errors/error-page';
import arrowRight from 'four-nets/icons/svg/icon_arrow-right.svg';

import Member from '../member/member';
import query, { GroupDetailLoaderQuery, GroupDetailLoaderQueryVariables } from './group-info-loader.graphql';
import defaultStyles from './group-info.scss';

export interface Props {
    styles: typeof defaultStyles;
    id: string;
}

class GroupInfo extends React.PureComponent<Props> {
    render() {
        const { id, styles } = this.props;
        return (
            <Query<GroupDetailLoaderQuery, GroupDetailLoaderQueryVariables> query={query} variables={{ id }}>
                {({ error, data, loading }) => (
                    <LoadingProgress loading={loading}>
                        <ErrorPage error={error}>
                            {data && data.group ? (
                                <div className={styles.wrapper}>
                                    <div className={classnames(styles.section, styles.noMargin)}>
                                        <div className={styles.sectionTitle}>
                                            <FormattedMessage id='GROUP_DESCRIPTION' />
                                        </div>
                                        <p className={styles.noMargin}>
                                            <EnhancedText>{data.group.description || ''}</EnhancedText>
                                        </p>
                                    </div>
                                    <div className={styles.section}>
                                        <div className={styles.sectionTitle}>
                                            <FormattedMessage id='GROUP_MEMBERS' />
                                        </div>
                                        <ul className={classnames(styles.noMargin, styles.noPadding)}>
                                            {data.group.members && data.group.members.edges
                                                ? data.group.members.edges.map(edge =>
                                                      edge && edge.node ? (
                                                          <Member key={edge.node.id} {...edge.node} />
                                                      ) : null
                                                  )
                                                : null}
                                        </ul>
                                        <Link to={`/group/${fromGlobalId(id).id}/members/`} className={styles.link}>
                                            <FormattedMessage id='DISPLAY_ALL_GROUP_MEMBERS' />
                                            <SVGIcon style={{ image: styles.icon }} src={arrowRight} />
                                        </Link>
                                    </div>
                                    <div className={styles.section}>
                                        <div className={styles.sectionTitle}>
                                            <FormattedMessage id='GROUP_RULES' />
                                        </div>
                                        <p className={styles.noMargin}>
                                            <EnhancedText>{data.group.rules || ''}</EnhancedText>
                                        </p>
                                    </div>
                                    <div className={styles.row}>
                                        <div className={styles.rowTile}>
                                            <div className={styles.section}>
                                                <div className={styles.sectionTitle}>
                                                    <FormattedMessage id='GROUP_ABOUT_CREATED' />
                                                </div>
                                                <FormattedDateAgoView value={new Date(data.group.createdTime)} />
                                            </div>
                                        </div>
                                        <div className={styles.rowTile}>
                                            <div className={styles.section}>
                                                <div className={styles.sectionTitle}>
                                                    <FormattedMessage id='GROUP_ABOUT_CREATED_BY' />
                                                </div>
                                                {data.group && data.group.user && displayedName(data.group.user)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </ErrorPage>
                    </LoadingProgress>
                )}
            </Query>
        );
    }
}

export default Styled(defaultStyles)(GroupInfo);
